<template>
  <div class="border-bottom my-4 pb-2">
    <b-row class="d-flex">
      <b-col class="order-2 order-md-1" cols="12" md="5">
        <h1 class="my-auto">{{ title }}</h1>
      </b-col>
      <b-col
        v-if="
          !$route.path.includes('edit') &&
          !$route.path.includes('create') &&
          $route.name !== 'meetings'
        "
        class="order-1 order-md-2 d-flex justify-content-md-end justify-content-center align-items-end"
        cols="12"
        md="7"
      >
        <template v-if="!$route.path.includes('documents') && meeting">
          <b-button
            v-if="
              meeting.building.has_building_owners &&
              meeting.building.has_charges_generales &&
              meeting.status > meetingStatuses.created &&
              !meeting.has_resolutions_without_keys
            "
            class="button mr-2 subnavbtn"
            variant="success"
            :to="{ name: 'meeting-documents', params: { id: meeting.id } }"
          >
            <font-awesome-icon icon="file-pdf" class="agv-button-icon" size="1x" />
            <span class="nav-item-text">Documents</span>
          </b-button>
          <b-button
            v-if="
              meeting.status == meetingStatuses.invitationSent ||
              meeting.status == meetingStatuses.started
            "
            class="button mr-2 subnavbtn"
            @click="openModalQrCode"
          >
            <font-awesome-icon icon="qrcode" class="agv-button-icon" />
            <span class="nav-item-text">QR code</span>
          </b-button>

          <b-button
            v-if="meeting.allowed_modalities.correspondence"
            class="button mr-2 subnavbtn"
            :class="[$route.name == 'meeting-correspondence' ? 'btn-blue' : 'btn-grey']"
            :to="{ name: 'meeting-correspondence' }"
          >
            <font-awesome-icon class="agv-button-icon" icon="envelope" />
            <span class="nav-item-text">Correspondance</span>
          </b-button>

          <b-button
            v-if="
              meeting.status != meetingStatuses.started &&
              meeting.status != meetingStatuses.completed &&
              meeting.status != meetingStatuses.pvReadyToBeSent &&
              meeting.status != meetingStatuses.pvInProgress
            "
            class="button mr-2 subnavbtn"
            :class="[$route.name == 'meeting-agenda' ? 'btn-blue' : 'btn-grey']"
            :to="{ name: 'meeting-agenda' }"
          >
            <font-awesome-icon class="agv-button-icon" icon="gavel" />
            <span class="nav-item-text">Résolutions</span>
          </b-button>

          <b-button
            v-if="
              meeting.status != meetingStatuses.started &&
              meeting.status != meetingStatuses.completed &&
              meeting.status != meetingStatuses.pvReadyToBeSent &&
              meeting.status != meetingStatuses.pvInProgress
            "
            class="button mr-2 subnavbtn"
            :class="[$route.name == 'meeting-presence' ? 'btn-blue' : 'btn-grey']"
            :to="{ name: 'meeting-presence' }"
          >
            <font-awesome-icon class="agv-button-icon" icon="user-check" />
            <span class="nav-item-text">Présence</span>
          </b-button>

          <b-button
            v-if="
              meeting.status == meetingStatuses.started ||
              meeting.status == meetingStatuses.completed ||
              meeting.status == meetingStatuses.pvReadyToBeSent ||
              meeting.status == meetingStatuses.pvInProgress
            "
            :to="{ name: 'meeting-start', params: { id: $route.params.id } }"
            class="button mr-2 subnavbtn"
            :class="[$route.name == 'meeting-start' && video == false ? 'btn-green' : 'btn-grey']"
            @click="$emit('setVideo', false)"
          >
            <font-awesome-icon class="agv-button-icon" icon="hand-paper" />
            <span class="nav-item-text">Les votes</span>
          </b-button>
          <b-button
            v-if="
              meeting.status == meetingStatuses.started &&
              meeting.allowed_modalities.video &&
              !meeting.external_video_solution
            "
            class="button mr-2 subnavbtn"
            :class="[$route.name == 'meeting-start' && video == true ? 'btn-green' : 'btn-grey']"
            @click="$emit('setVideo', true)"
          >
            <font-awesome-icon class="agv-button-icon" icon="video" />
            <span class="nav-item-text">Videoconference</span>
          </b-button>
        </template>
        <template v-if="$route.path.includes('documents') && meeting">
          <b-button
            v-if="meeting.status < meetingStatuses.invitationSent"
            class="button mr-2 subnavbtn"
            :to="{ name: 'edit-meeting' }"
          >
            <font-awesome-icon class="agv-button-icon" icon="pen" />
            <span class="nav-item-text">Modifier</span>
          </b-button>
          <b-button
            v-if="
              [
                meetingStatuses.invitationSent,
                meetingStatuses.invitationReadyToBeSent,
                meetingStatuses.invitationInProgress,
              ].includes(meeting.status)
            "
            class="button mr-2 subnavbtn"
            @click="goToMeetingStart()"
          >
            <font-awesome-icon class="agv-button-icon" icon="play" />
            <span class="nav-item-text">Démarrer</span>
          </b-button>
          <b-button
            v-if="[meetingStatuses.started].includes(meeting.status)"
            class="button mr-2 subnavbtn"
            @click="goToMeetingStart()"
          >
            <font-awesome-icon class="agv-button-icon" icon="pause" />
            <span class="nav-item-text">Convocation en cours</span>
          </b-button>
          <b-button
            v-if="
              [
                meetingStatuses.completed,
                meetingStatuses.pvReadyToBeSent,
                meetingStatuses.pvInProgress,
              ].includes(meeting.status)
            "
            class="button mr-2 subnavbtn"
            :to="{ name: 'meeting-start' }"
          >
            <font-awesome-icon class="agv-button-icon" icon="history" />
            <span class="nav-item-text">Voir l'historique</span>
          </b-button>
        </template>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
      </b-col>
    </b-row>
    <b-modal
      v-if="meeting && showQrCodeModal"
      :id="`qr-code-${meeting.id}`"
      :visible="true"
      size="md"
      hide-footer
      centered
      @hide="closeModalQrCode"
    >
      <template #modal-title>
        <div>Accéder a l'interface de présence</div>
      </template>
      <div class="d-flex justify-content-center">
        <img :src="qrBase64Image" alt="qr-code" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import QRCode from "qrcode";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    breadcrumbs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    video: {
      type: Boolean,
      default: false,
    },
    meeting: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      qrBase64Image: "",
      showQrCodeModal: false,
    };
  },
  computed: {
    timezone() {
      return localStorage.getItem("timezone");
    },
  },
  watch: {
    meeting(newValue) {
      if (newValue) {
        this.createQrCode();
      }
    },
  },
  methods: {
    openModalQrCode() {
      this.showQrCodeModal = true;
    },
    closeModalQrCode() {
      this.showQrCodeModal = false;
    },
    createQrCode() {
      let self = this;
      let meetingId = null;
      if (this.meeting) {
        meetingId = this.meeting.id;
      } else if (this.$route.params && this.$route.params.id) {
        meetingId = this.$route.params.id;
      } else {
        return;
      }
      const host = window.location.origin;
      const meetingRegisterPath = this.$router.resolve({
        name: "meeting-register",
        params: { id: meetingId },
      });
      let url = host + meetingRegisterPath.href + `?tz=${this.timezone}`;

      QRCode.toDataURL(url, function (err, url) {
        self.qrBase64Image = url;
        if (err) {
          console.log(err);
        }
      });
    },
    goToMeetingStart() {
      if (
        this.meeting.status == this.meetingStatuses.invitationSent ||
        this.meeting.status == this.meetingStatuses.invitationReadyToBeSent ||
        this.meeting.status == this.meetingStatuses.invitationInProgress
      ) {
        this.$router.push({ name: "meeting-agenda", params: { id: this.meeting.id } });
      } else {
        this.$router.push({ name: "meeting-start", params: { id: this.meeting.id } });
      }
    },
  },
};
</script>
